import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { debounce } from 'debounce';
import { useSafeState } from '@beef/react';
import { DISPLAY_WIDTH } from "../constants/dimensions";
export var DIMENSION_GROUPS;

/**
 * FIXME: Remove duplication, move hook to @beef/react ? or @beef/ui-kit
 */
(function (DIMENSION_GROUPS) {
  DIMENSION_GROUPS["mobile"] = "mobile";
  DIMENSION_GROUPS["tablet"] = "tablet";
  DIMENSION_GROUPS["desktop"] = "desktop";
})(DIMENSION_GROUPS || (DIMENSION_GROUPS = {}));
export var useGetDimensionGroup = function useGetDimensionGroup() {
  var _useSafeState = useSafeState(null),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    group = _useSafeState2[0],
    setGroup = _useSafeState2[1];
  useEffect(function () {
    var handleResize = debounce(function () {
      if (!window) {
        setGroup(null);
      }
      if (window.innerWidth < DISPLAY_WIDTH.MOBILE) {
        setGroup(DIMENSION_GROUPS.mobile);
      } else if (window.innerWidth >= DISPLAY_WIDTH.MOBILE && window.innerWidth < DISPLAY_WIDTH.TABLET) {
        setGroup(DIMENSION_GROUPS.tablet);
      } else {
        setGroup(DIMENSION_GROUPS.desktop);
      }
    }, 100);
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return group;
};
export var useIsMobileDimension = function useIsMobileDimension() {
  var dimension = useGetDimensionGroup();
  return dimension === DIMENSION_GROUPS.mobile;
};
export var useIsTabletDimension = function useIsTabletDimension() {
  var dimension = useGetDimensionGroup();
  return dimension === DIMENSION_GROUPS.tablet;
};
export var useIsDesktopDimension = function useIsDesktopDimension() {
  var dimension = useGetDimensionGroup();
  return dimension === DIMENSION_GROUPS.desktop;
};